import { createContext, useContext, useEffect, useRef, useState } from "react";
import Lenis from "lenis";

const SmoothScrollContext = createContext({ scrollTo: () => {} });

export const useSmoothScroll = () => useContext(SmoothScrollContext);

export function SmoothScrollProvider({ children }) {
  const lenisRef = useRef(null);
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.5,
    });
    lenisRef.current = instance;
    setLenis(instance);

    let rafId;
    function raf(time) {
      instance.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      instance.destroy();
    };
  }, []);

  const scrollTo = (target, opts = {}) => {
    const lenis = lenisRef.current;
    if (!lenis) {
      if (typeof target === "string") {
        const el = document.querySelector(target);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }
      return;
    }
    const options = { offset: -80, duration: 1.2, ...opts };
    lenis.scrollTo(target, options);

    // As imagens da galeria carregam em lazy e empurram o conteúdo enquanto
    // a animação decorre — sem isto o scroll parava muito antes do destino.
    // Re-resolver o alvo até o layout assentar.
    if (typeof target === "string") {
      let tries = 0;
      const retarget = () => {
        const el = document.querySelector(target);
        if (!el || tries >= 8) return;
        const want = el.getBoundingClientRect().top + window.scrollY + (options.offset || 0);
        if (Math.abs(want - window.scrollY) > 4) {
          tries += 1;
          lenis.scrollTo(el, { offset: options.offset, duration: 0.5 });
          window.setTimeout(retarget, 600);
        }
      };
      window.setTimeout(retarget, 1300);
    }
  };

  return (
    <SmoothScrollContext.Provider value={{ scrollTo, lenis }}>
      {children}
    </SmoothScrollContext.Provider>
  );
}
